<div class="container"> 
    <p > Usuario creado exitosamente! </p>
    <strong><p>Por favor, revise su mail (y/o spam) para ver sus datos de ingreso</p></strong> 
</div>

